var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.39,
    height: 143.39,
    viewBox: "0 0 143.39 143.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M75.07,3.375a71.7,71.7,0,1,0,71.7,71.7A71.684,71.684,0,0,0,75.07,3.375Zm18.165,97.65L75.07,82.86,56.905,101.025a5.508,5.508,0,1,1-7.79-7.79L67.28,75.07,49.115,56.905a5.508,5.508,0,0,1,7.79-7.79L75.07,67.28,93.235,49.115a5.508,5.508,0,0,1,7.79,7.79L82.86,75.07l18.165,18.165a5.534,5.534,0,0,1,0,7.79A5.472,5.472,0,0,1,93.235,101.025Z",
    transform: "translate(-3.375 -3.375)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.2b6227a278d399757488021c1d3d1d0b.svg";
export { ForwardRef as ReactComponent };